import React from 'react';

/**
 * Represents piano gated content.  This currently functions
 * as a placeholder for now
 */
export function PianoGatedContent() {
  return (
    <div className="piano-gate">
      <div className="paywallGate" />
    </div>
  );
}
